import {useParams} from 'react-router-dom'
import {
  fetchContactFormData,
  getContactFormData,
  getContactFormDataLoading,
  postContactFormData,
} from './EndUserSlice/EndUserSlice'
import {useDispatch, useSelector} from 'react-redux'
import {useEffect, useRef, useState} from 'react'
import {Form, Spinner} from 'react-bootstrap'

function fromCamelCase(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before uppercase letters
    .replace(/^./, (char) => char.toUpperCase()) // Capitalize first letter
}

const FormPage = () => {
  const param = useParams()
  const dispatch = useDispatch()
  const contactFormData = useSelector(getContactFormData)
  const isLoading = useSelector(getContactFormDataLoading)
  const formRef = useRef<HTMLFormElement>(null)
  const [isConfirmed, setIsConfirmed] = useState(false)

  useEffect(() => {
    dispatch(fetchContactFormData({id: param.id}))
  }, [dispatch, param.id])

  // Handle form submission
  const handleSubmit = (e: any) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    if (isConfirmed) {
      formData.append('marketingOptIn', 'true')
    }

    const data = Object.fromEntries(formData.entries())

    dispatch(
      postContactFormData({
        id: param.id,
        data,
      })
    ).then((res: any) => {
      if (res?.payload?.data?.redirectUrl) {
        window.location.href = res?.payload?.data?.redirectUrl
      }
      formRef.current?.reset()
    })
  }

  return (
    <div className='d-flex justify-content-center align-items-center vh-100 ms-5 me-5'>
      <div className='card' style={{width: '50rem'}}>
        {contactFormData == null ? (
          <div className='card-body justify-content-center align-items-center w-100'>
            <div className='alert alert-info d-inline-block w-100' role='alert'>
              <p className='mb-0'>Your form is not available</p>
            </div>
          </div>
        ) : (
          <div className='card-body'>
            {contactFormData?.logo && (
              <div
                className='d-flex justify-content-center align-items-center mb-4'
                style={{height: '140px'}} // Optional height to vertically center if needed
              >
                <img
                  src={contactFormData.logo} // Replace with your actual logo path
                  alt='Logo'
                  style={{
                    maxWidth: '250px',
                    maxHeight: '150px',
                    objectFit: 'contain',
                  }}
                />
              </div>
            )}

            <h1 className='card-title'>{contactFormData?.name.toUpperCase()}</h1>
            <p className='card-text text-muted mb-10'>{contactFormData?.description}</p>
            <form ref={formRef} onSubmit={handleSubmit}>
              {contactFormData?.fields.map((field: any) => (
                <div key={field._id} className='mb-3'>
                  <label htmlFor={field.name} className='form-label'>
                    {fromCamelCase(field.name)}
                  </label>
                  <input
                    type={field.type}
                    className='form-control'
                    id={field.name}
                    name={field.name}
                    required
                  />
                </div>
              ))}
              {contactFormData?.isMarketingMessageOptIn && (
                <Form.Group controlId='confirmationCheckbox' className='mb-3'>
                  <Form.Check
                    inline
                    type='checkbox'
                    label={
                      contactFormData?.marketingMessageOptin
                        ? contactFormData?.marketingMessageOptin
                        : 'Would you like to receive updates about future offers, events, and exclusive deals?'
                    }
                    checked={isConfirmed}
                    onChange={(e) => setIsConfirmed(e.target.checked)}
                  />
                </Form.Group>
              )}
              <button type='submit' className='btn btn-primary w-100'>
                {isLoading ? <Spinner /> : 'Submit'}
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  )
}

export default FormPage
